import AddToListButton from '@/components/Wishlist/AddToListButton';
import { useMemo } from 'react';
import { ProductRoot } from '../types/product';

export const WishlistButton = ({
  product,
  selectedOptionsArray,
  classes,
}: {
  product: ProductRoot;
  selectedOptionsArray: any[];
  classes?: {
    root?: string;
    root_selected?: string;
  };
}) => {
  const productType = product?.__typename;

  const wishlistItemOptions = useMemo(() => {
    const options: {
      quantity: number;
      sku: string;
      selected_options?: any[];
    } = {
      quantity: 1,
      sku: product.sku,
    };

    if (productType === 'ConfigurableProduct') {
      options.selected_options = selectedOptionsArray;
    }

    return options;
  }, [product, productType, selectedOptionsArray]);

  const wishlistButtonProps = {
    buttonText: (isSelected: any) => (isSelected ? 'Go to Showroom' : 'Add to Showroom'),
    item: wishlistItemOptions,
    storeConfig: {},
    classes,
  };

  return <AddToListButton {...wishlistButtonProps} />;
};
